export class DateUtils {
  static convertDateForBackend(date: Date): string {
    let month: string;
    let day: string;

    if (date.getMonth() < 9) {
      month = '0' + (date.getMonth() + 1);
    } else {
      month = (date.getMonth() + 1).toString();
    }

    if (date.getDate() < 10) {
      day = '0' + date.getDate();
    } else {
      day = date.getDate().toString();
    }

    return date.getFullYear() + '-' + month + '-' + day;
  }

  static convertBackendDateToDate(date: string): Date {
    // Dates from the backend will look like: YYYY-MM-DD
    return new Date(date);
  }
}
